export const TABLES = {
  userProfiles: 'user_profiles',
  userStats: 'user_stats',
  userPreferences: 'user_preferences',
  releases: 'releases',
  downloadEvents: 'download_events',
  newsletterSubscribers: 'newsletter_subscribers',
} as const;

export const RPC = {
  userStatsIncrement: 'user_stats_increment',
  logDownload: 'log_download',
} as const;

export const COLUMNS = {
  userProfiles: {
    userId: 'user_id',
    email: 'email',
    displayName: 'display_name',
    avatarUrl: 'avatar_url',
    plan: 'plan',
    registeredAt: 'registered_at',
    lastActiveAt: 'last_active_at',
    appVersionRegistered: 'app_version_registered',
    appVersionLast: 'app_version_last',
    platform: 'platform',
    isOnboarded: 'is_onboarded',
    marketingOptedIn: 'marketing_opted_in',
  },
  userStats: {
    meetingsAlertedTotal: 'meetings_alerted_total',
    meetingsJoinedTotal: 'meetings_joined_total',
    meetingsSnoozedTotal: 'meetings_snoozed_total',
    appOpensTotal: 'app_opens_total',
    calendarsConnectedTotal: 'calendars_connected_total',
  },
  releases: {
    id: 'id',
    version: 'version',
    channel: 'channel',
    releasedAt: 'released_at',
    notesMd: 'notes_md',
    windowsUrl: 'windows_url',
    windowsSha256: 'windows_sha256',
    macosUrl: 'macos_url',
    macosSha256: 'macos_sha256',
    isPublished: 'is_published',
  },
} as const;

export const PLANS = {
  free: 'free',
  pro: 'pro',
} as const;
export type Plan = (typeof PLANS)[keyof typeof PLANS];

export const PLATFORMS = {
  windows: 'windows',
  macos: 'macos',
} as const;
export type Platform = (typeof PLATFORMS)[keyof typeof PLATFORMS];

export const CHANNELS = {
  stable: 'stable',
  beta: 'beta',
} as const;
export type ReleaseChannel = (typeof CHANNELS)[keyof typeof CHANNELS];
